// @flow


import type {
    PhotoEBadgeBulkDeleteFailedAction,
    PhotoEBadgeBulkDeleteStartAction,
    PhotoEBadgeBulkDeleteSuccessAction,
    PhotoEBadgeCloseBulkDeletePhotoModalAction,
    PhotoEBadgeCloseDeletePhotoModalAction,
    PhotoEBadgeDeleteFailedAction,
    PhotoEBadgeDeleteStartAction,
    PhotoEBadgeDeleteSuccessAction,
    PhotoEBadgeOpenBulkDeletePhotoModalAction,
    PhotoEBadgeOpenDeletePhotoModalAction,
    TogglePhotoAction
} from "../photoEBadgeAction";
import {Dispatch} from "redux";
import type {StoreState} from "../../../../reducers/combinedReducers";
import {bulkDeleteEBadgePhoto, deleteEBadgePhoto} from "../../../../dao/eBadgeDao";
import {ThunkAction} from "redux-thunk";
import {photoEBadgeQueryAction} from "./photoEBadgeQueryActionCreator";
import type {PhotoEBadgeSearchCriteria} from "../../../../components/ebadge/photo/PhotoEBadgeSearchForm";
import type {Caller} from "../../../../components/QueryPage";

function photoEBadgeBulkDeleteStartAction(registrationCodes: Array<string>): PhotoEBadgeBulkDeleteStartAction {
    return {
        type: "ebadge/photo/BULK_DELETE_START_ACTION",
        registrationCodes
    };
}

function photoEBadgeBulkDeleteSuccessAction(registrationCodes: Array<string>): PhotoEBadgeBulkDeleteSuccessAction {
    return {
        type: "ebadge/photo/BULK_DELETE_SUCCESS_ACTION",
        registrationCodes
    }
}

function photoEBadgeBulkDeleteFailedAction(registrationCodes:Array<string>, error: any): PhotoEBadgeBulkDeleteFailedAction {
    return {
        type: "ebadge/photo/BULK_DELETE_FAILED_ACTION",
        registrationCodes,
        error
    }
}

export function photoEBadgeBulkDeleteAction(registrationCodes: Array<string>, caller: Caller): ThunkAction {

    return async (dispatch: Dispatch, getState: ?() => StoreState) => {

        try {

            if (getState) {

                dispatch(photoEBadgeBulkDeleteStartAction(registrationCodes));
                await bulkDeleteEBadgePhoto(registrationCodes, caller, getState().loginUser.jwt);
                dispatch(photoEBadgeBulkDeleteSuccessAction(registrationCodes));

                const criteria: ?PhotoEBadgeSearchCriteria = getState().photoEBadgeQuery.criteria;
                if (criteria) {
                    dispatch(photoEBadgeQueryAction(criteria));
                }
            } else {
                throw new Error("Unexpected Error");
            }
        } catch (e) {

            dispatch(photoEBadgeBulkDeleteFailedAction(registrationCodes, e));
        }

    };
}

function photoEBadgeDeleteStartAction(registrationCode: string): PhotoEBadgeDeleteStartAction {
    return {
        type: "ebadge/photo/DELETE_START_ACTION",
        registrationCode
    };
}

function photoEBadgeDeleteSuccessAction(registrationCode: string): PhotoEBadgeDeleteSuccessAction {
    return {
        type: "ebadge/photo/DELETE_SUCCESS_ACTION",
        registrationCode
    }
}

function photoEBadgeDeleteFailedAction(registrationCode:string, error: any): PhotoEBadgeDeleteFailedAction {
    return {
        type: "ebadge/photo/DELETE_FAILED_ACTION",
        registrationCode,
        error
    }
}

export function photoEBadgeDeleteAction(registrationCode: string, caller: Caller): ThunkAction {

    return async (dispatch: Dispatch, getState: ?() => StoreState) => {

        try {

            if (getState) {

                dispatch(photoEBadgeDeleteStartAction(registrationCode));
                await deleteEBadgePhoto(registrationCode, caller, getState().loginUser.jwt);
                dispatch(photoEBadgeDeleteSuccessAction(registrationCode));

                const criteria: ?PhotoEBadgeSearchCriteria = getState().photoEBadgeQuery.criteria;
                if (criteria) {
                    dispatch(photoEBadgeQueryAction(criteria));
                }
            } else {
                throw new Error("Unexpected Error");
            }
        } catch (e) {

            dispatch(photoEBadgeDeleteFailedAction(registrationCode, e));
        }

    };
}

export function openDeleteEBadgePhotoModalAction(registrationCode: string): PhotoEBadgeOpenDeletePhotoModalAction {
    return {
        type: "ebadge/photo/OPEN_DELETE_MODAL",
        registrationCode
    }
}

export function closeDeleteEBadgePhotoModalAction(): PhotoEBadgeCloseDeletePhotoModalAction {
    return {
        type: "ebadge/photo/CLOSE_DELETE_MODAL"
    }
}

export function openBulkDeleteEBadgePhotoModalAction(): PhotoEBadgeOpenBulkDeletePhotoModalAction {
    return {
        type: "ebadge/photo/OPEN_BULK_DELETE_MODAL"
    }
}

export function closeBulkDeleteEBadgePhotoModalAction(): PhotoEBadgeCloseBulkDeletePhotoModalAction {
    return {
        type: "ebadge/photo/CLOSE_BULK_DELETE_MODAL"
    }
}

export function togglePhotoAction(registrationCode: string): TogglePhotoAction {
    return {
        type: "ebadge/photo/TOGGLE_PHOTO",
        registrationCode
    }
}


// WEBPACK FOOTER //
// ./src/actions/ebadge/photo/creators/photoEBadgeActionCreator.js